module.exports = __webpack_public_path__ + "static/bar_chart_4-91a51d8010e299c58b9576ff132b58b9.png";